"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandableTableRow = ExpandableTableRow;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _image = _interopRequireDefault(require("next/image"));
var _table = require("./table");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ExpandableTableRow(_ref) {
  var {
    children,
    expandableContent,
    expanded,
    expandIcon,
    collapseIcon,
    testId,
    onTableRowExpanded
  } = _ref;
  if (!children.length) {
    children = [children];
  }
  var handleOnExpandedClick = () => {
    onTableRowExpanded && onTableRowExpanded(!expanded);
  };
  var modifiedChildren = children.map((child, index) => {
    var props = child.props;
    return (0, _react.createElement)(_table.TableCell, _objectSpread(_objectSpread({}, props), {}, {
      key: index
    }), (0, _jsxRuntime.jsxs)("div", {
      className: cellStyle,
      children: [(0, _jsxRuntime.jsx)("div", {
        children: props.children
      }), index === children.length - 1 && (0, _jsxRuntime.jsx)(_image.default, {
        "data-testid": "Expand-Collapse-Icon",
        src: expanded ? collapseIcon : expandIcon,
        alt: expanded ? 'collapse' : 'expand',
        width: 24,
        height: 24
      })]
    }));
  });
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_table.TableRow, {
      "data-testid": testId,
      onClick: () => handleOnExpandedClick(),
      className: rowStyle,
      children: modifiedChildren
    }), expanded && (0, _jsxRuntime.jsx)(_table.TableRow, {
      "data-testid": "".concat(testId, "-expanded"),
      children: (0, _jsxRuntime.jsx)(_table.TableCell, {
        colSpan: children.length,
        className: expandableContentStyle,
        children: expandableContent
      })
    })]
  });
}
var rowStyle = 'cursor-pointer';
var cellStyle = 'flex justify-between items-center';
var expandableContentStyle = 'bg-lightGrey4';